import {
  FirestoreDocumentChange,
  FirestoreQuerySnapshot,
  FirebaseFirestore,
} from '../../drivers/Firestore';
import { User } from '../../domain/entities';

export const disabledInstructorListener = (
  firestore: FirebaseFirestore,
  callback: (instructor: Array<User>) => void,
): void => {
  try {
    firestore
      .collection('users')
      .where('roles.lecturer', '==', true)
      .where('isDeleted', '==', false)
      .onSnapshot((querySnapshot: FirestoreQuerySnapshot) => {
        const instructor: User[] = [];
        querySnapshot
          .docChanges()
          .forEach((change: FirestoreDocumentChange) => {
            if (change.type === 'added' || change.type === 'modified') {
              // @ts-ignore
              const data: User = change.doc.data();
              instructor.push(data);
            }
          });
        if (instructor.length > 0) {
          callback(instructor);
        }
      });
  } catch (error) {
    throw error;
  }
};
